import { Navigate, Outlet } from 'react-router-dom'
export default function PrivateRoutes ()  {
    let auth = {'token': sessionStorage.getItem('token') ? true : false}
    
    return (
      auth.token ? <Outlet/> : <Navigate to='/auth/login'/>
    )
  }